/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  ExecutableScript,
  ExecuteScriptParams,
  ExecuteScriptResult,
  Script,
  SignerProvider,
  HexString,
} from "@alephium/web3";
import { getContractByCodeHash } from "./contracts";
import { default as RocketRangeCreateRoundTXScriptJson } from "../rocket_range/RocketRangeCreateRoundTX.ral.json";
import { default as RocketRangeSetOpenPriceTXScriptJson } from "../rocket_range/RocketRangeSetOpenPriceTX.ral.json";
import { default as UpdateRocketRangeLeaderboardTXScriptJson } from "../rocket_range/UpdateRocketRangeLeaderboardTX.ral.json";
import {
  LeaderboardEntry,
  LeaderboardPeriodicTop,
  RocketRangeGameInstance,
  RocketRangeGameSettings,
  RocketRangeOracleValue,
  RocketRangeUserBet,
  UpgradableSettings,
  AllStructs,
} from "./types";

export const RocketRangeCreateRoundTX = new ExecutableScript<{
  rocketRange: HexString;
}>(
  Script.fromJson(RocketRangeCreateRoundTXScriptJson, "", AllStructs),
  getContractByCodeHash
);

export const RocketRangeSetOpenPriceTX = new ExecutableScript<{
  rocketRange: HexString;
  roundId: bigint;
}>(
  Script.fromJson(RocketRangeSetOpenPriceTXScriptJson, "", AllStructs),
  getContractByCodeHash
);

export const UpdateRocketRangeLeaderboardTX = new ExecutableScript<{
  rocketRange: HexString;
  leaderboard: HexString;
}>(
  Script.fromJson(UpdateRocketRangeLeaderboardTXScriptJson, "", AllStructs),
  getContractByCodeHash
);
